import React from 'react';

import TireComparisonChart from '../tire-comparison-chart/tire-comparison-chart';
import TireComparisonTable from '../tire-comparison-table/tire-comparison-table';

interface TireComparisonProps {
  currentDistance: number;
  currentProductLabel?: string;
  currentRank: number;
  currentWornDistance?: number;
  hideRecommended?: boolean;
  isDry?: boolean;
  isLT?: boolean;
  isWet?: boolean;
  recommendedDistance: number;
  recommendedProductLabel: string;
  recommendedProductUrl: string;
  recommendedRank: number;
  recommendedWornDistance?: number;
}

function TireComparison(props: TireComparisonProps) {
  return (
    <div>
      <TireComparisonChart {...props} />
      <TireComparisonTable {...props} />
    </div>
  );
}

export default TireComparison;
